/**
 * Phase 33 §6 — Browser Profile + Per-Browser Performance Tuning.
 *
 * Detects browser family and exposes a tuning config consumed by:
 *  - polling cadence
 *  - rerender-frequency limits
 *  - animation toggle
 *  - requestIdleCallback fallbacks
 */

function detect() {
  if (typeof navigator === 'undefined') return 'unknown';
  const ua = navigator.userAgent || '';
  // Order matters — Edge spoofs Chrome ua.
  if (/Edg\//.test(ua))        return 'edge';
  if (/Firefox\//.test(ua))    return 'firefox';
  if (/Chrome\//.test(ua))     return 'chrome';
  if (/Safari\//.test(ua) && /Version\//.test(ua)) return 'safari';
  return 'unknown';
}

const family = detect();

// Per-browser cadence multipliers (1.0 = baseline).
const PROFILES = {
  chrome:  { poll_mult: 1.25, anim: 'minimal',  idle_callback: true,  rerender_throttle_ms: 80 },
  edge:    { poll_mult: 1.10, anim: 'normal',   idle_callback: true,  rerender_throttle_ms: 60 },
  firefox: { poll_mult: 1.00, anim: 'normal',   idle_callback: false, rerender_throttle_ms: 50 },
  safari:  { poll_mult: 1.15, anim: 'normal',   idle_callback: false, rerender_throttle_ms: 70 },
  unknown: { poll_mult: 1.00, anim: 'normal',   idle_callback: false, rerender_throttle_ms: 50 },
};

const profile = PROFILES[family] || PROFILES.unknown;

// Safe wrapper around requestIdleCallback for non-critical hydration.
const _idleCallback = (cb, opts = { timeout: 200 }) => {
  if (typeof window === 'undefined') { cb(); return 0; }
  if (profile.idle_callback && typeof window.requestIdleCallback === 'function') {
    return window.requestIdleCallback(cb, opts);
  }
  return setTimeout(cb, 0);
};

const browserProfile = {
  family,
  ...profile,
  isChrome:  family === 'chrome',
  isMobile:  typeof navigator !== 'undefined' && /Mobi|Android/i.test(navigator.userAgent || ''),
  idleCallback: _idleCallback,
  // Suggested polling interval given a base.
  poll(base_ms) {
    return Math.round(base_ms * profile.poll_mult);
  },
};

export default browserProfile;
